// User Repository for localStorage Operations
// Handles user data persistence in localStorage

import type { User as AuthUser } from '@/domains/auth/types/User';

const USER_CACHE_KEY = 'hplite_user';

// --- Public API: Get Operations ---
export const getUserFromCache = async (): Promise<AuthUser | null> => {
  try {
    const cached = localStorage.getItem(USER_CACHE_KEY);
    if (!cached) {
      return null;
    }
    return JSON.parse(cached) as AuthUser;
  } catch (error) {
    console.error('Failed to get user from cache:', error);
    return null;
  }
};

// --- Public API: Update Operations ---
export const saveUserToCache = async (user: AuthUser): Promise<void> => {
  try {
    localStorage.setItem(USER_CACHE_KEY, JSON.stringify(user));
  } catch (error) {
    console.error('Failed to save user to cache:', error);
    throw error;
  }
};

// --- Public API: Delete Operations ---
export const clearUserCache = async (): Promise<void> => {
  try {
    localStorage.removeItem(USER_CACHE_KEY);
  } catch (error) {
    console.error('Failed to clear user cache:', error);
    throw error;
  }
};
